/**
 * Keeps design-board read caches scoped to the active Firebase Auth user.
 */
import { clearDesignBoardAttachableFileProbeCache } from "./utils/designBoardAttachableFileModel";
import {
  clearDesignBoardFileReadUrlCache,
  syncDesignBoardFileReadUrlCacheUser,
} from "./utils/designBoardFileReadUrlCache";
import { clearDesignBoardProjectFileReadResolverState } from "./utils/designBoardProjectFileReadResolver";

export function bindDesignBoardReadCacheAuth(auth) {
  if (!auth || typeof auth.onAuthStateChanged !== "function") return;
  auth.onAuthStateChanged((user) => {
    syncDesignBoardFileReadUrlCacheUser(user?.uid || "");
    clearDesignBoardProjectFileReadResolverState();
    clearDesignBoardAttachableFileProbeCache();
  });
}

export function resetDesignBoardReadCachesForSignOut() {
  clearDesignBoardFileReadUrlCache();
  clearDesignBoardProjectFileReadResolverState();
  clearDesignBoardAttachableFileProbeCache();
}
